import { render, staticRenderFns } from "./boardList.vue?vue&type=template&id=0faec88d&scoped=true&"
import script from "./boardList.vue?vue&type=script&lang=js&"
export * from "./boardList.vue?vue&type=script&lang=js&"
import style0 from "./boardList.vue?vue&type=style&index=0&id=0faec88d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0faec88d",
  null
  
)

export default component.exports